import { Link } from "react-router-dom";
import { ChevronDown, Scissors, Package, Stethoscope } from "lucide-react";
import EntMegaMenuPanel from "@/components/EntMegaMenuPanel";

const SOLM_LINKS = [
  ["diabetes-care", "Diabetes Care"],
  ["medication-delivery", "Medication Delivery"],
  ["blood-collection", "Blood Collection"],
  ["wound-care", "Wound Care"],
  ["ppe", "PPE"],
  ["vascular-access", "Vascular Access & Infusion"],
  ["incontinence", "Incontinence"],
  ["bulk-non-sterile", "Bulk Non-Sterile"],
];

/**
 * Hover dropdown showing Surgical + all Sol-M category links + ENT mega-menu.
 * Used in the marketplace page headers.
 */
export default function CatalogNavDropdown({ className = "" }) {
  return (
    <div className={`relative group ${className}`} data-testid="catalog-nav-dropdown">
      <button className="inline-flex items-center gap-1 text-sm text-white bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg px-3 py-2 transition-colors" data-testid="catalog-nav-toggle">
        <Scissors className="w-3.5 h-3.5" />
        Marketplace
        <ChevronDown className="w-3.5 h-3.5" />
      </button>
      <div className="absolute right-0 top-full pt-2 w-[920px] max-w-[95vw] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
        <div className="bg-[#0b1d3a] border border-slate-700 rounded-xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-[260px_minmax(0,1fr)]">
            {/* Left: Surgical + Sol-M */}
            <div className="border-r border-slate-800 max-h-[70vh] overflow-y-auto">
              <Link
                to="/sterilemate/surgical"
                className="block px-4 py-3 hover:bg-slate-800/60 border-b border-slate-800"
                data-testid="dropdown-surgical">
                <p className="text-sm font-semibold text-white flex items-center gap-2">
                  <Scissors className="w-3.5 h-3.5" /> Surgical Marketplace
                </p>
                <p className="text-xs text-slate-400 ml-5">2,000+ SKUs · Aspen Medical, BluBox</p>
              </Link>
              <div className="px-4 py-2">
                <p className="text-[10px] font-semibold text-cyan-300 uppercase tracking-wider flex items-center gap-1.5">
                  <Package className="w-3 h-3" /> Sol-M Authorized Distributor
                </p>
              </div>
              {SOLM_LINKS.map(([slug, name]) => (
                <Link
                  key={slug}
                  to={`/sterilemate/${slug}`}
                  className="block px-4 py-2 text-sm text-slate-300 hover:text-white hover:bg-slate-800/60"
                  data-testid={`dropdown-${slug}`}>
                  {name}
                </Link>
              ))}
            </div>
            {/* Right: ENT mega-menu (category + instrument type) */}
            <div>
              <div className="px-4 py-3 border-b border-slate-800">
                <p className="text-sm font-semibold text-white flex items-center gap-2">
                  <Stethoscope className="w-3.5 h-3.5 text-purple-300" /> ENT — BEAR-ENT
                </p>
                <p className="text-xs text-slate-400 ml-5">93+ SKUs · Ear, Nose, Throat + Sets</p>
              </div>
              <EntMegaMenuPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
